/* global moment, XLSX */
angular
  .module('washesRevenueDetail')
  .component('washesRevenueDetail', {
    template: require('./washes-revenue-detail.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$routeParams', 'AuthService', 'envService',
      function WashRevenueDetailController($rootScope, $scope, $resource, $route, $location, $window, $translate, $routeParams, AuthService, envService) {
        $rootScope.mainmenu = 'washes';
        $rootScope.menu = 'washRevenue';
        $scope.doLogout = $rootScope.doLogout;
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        this.loginMember = $rootScope.loginMember;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isLevel2Authenticated()) {
          $location.path('/login');
          return;
        }
        const { month } = $routeParams;
        $resource(`${APIURL}/admin/stat/revenue/${month}`).get({}, (data) => {
          this.orders = data.orders;
          this.txtMonth = moment(month).format('MMMM, YYYY');
          this.total = this.orders.reduce((acc, value) => {
            acc.PRICE += value.PRICE;
            acc.TOTAL_PRICE += value.TOTAL_PRICE;
            acc.COUPON_USE += value.COUPON_USE;
            acc.MILEAGE_USE += value.MILEAGE_USE;
            acc.BM_POINT_USE += value.BM_POINT_USE;
            acc.ADJUST_PRICE += value.ADJUST_PRICE;
            acc.MILEAGE_REFUNDED += value.MILEAGE_REFUNDED;
            acc.REFUND_PRICE_BY_ACCOUNT += value.REFUND_PRICE_BY_ACCOUNT;
            acc.REFUND_COUPON_PRICE += value.REFUND_COUPON_PRICE;
            if (value.PAYMENT_METHOD === '91') {
              acc.GENESIS_PRICE += value.PRICE;
            }
            acc.COUNT += 1;
            return acc;
          }, { COUNT: 0, PRICE: 0, TOTAL_PRICE: 0, COUPON_USE: 0, GENESIS_PRICE: 0, MILEAGE_USE: 0, ADJUST_PRICE: 0, MILEAGE_REFUNDED: 0, REFUND_PRICE_BY_ACCOUNT: 0, REFUND_COUPON_PRICE: 0, BM_POINT_USE: 0 });
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });

        this.download = (name = 'default') => {
          let data = angular.copy(this.orders)
            .map((order) => {
              order.STATUS_NAME = $translate.instant(order.STATUS_NAME);
              order.ORDER_START_DATE = moment(order.ORDER_START_DATE_UTC).format('LLL');
              order.REGDATE = moment(order.REGDATE_UTC).format('LLL');
              delete order.STATUS;
              delete order.ORDER_START_DATE_UTC;
              delete order.REGDATE_UTC;
              delete order.MODIFY_REFUND_TYPE;
              return order;
            });
          if (!Array.isArray(data)) {
            data = [data];
          }
          const ws = XLSX.utils.json_to_sheet(data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, name);
          /* write workbook and force a download */
          XLSX.writeFile(wb, `${this.txtMonth}.xlsx`);
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/washes-revenue-detail/washes-revenue-detail.component.js